import React from 'react'
import styled from 'styled-components'
import { PlanDataInterface } from 'src/interfaces/plan'
import { formatNumPrice } from 'src/utils/helper'

interface PlanMessageProps {
  content: PlanDataInterface
  isImportant?: boolean
}

const PlanMessage: React.FC<PlanMessageProps> = ({ content, isImportant }) => {
  const {
    name,
    medicines = [],
    tags = [],
    treatment_policy = '',
    price_first,
    price_after,
    image_url,
  } = content

  return (
    <Wrapper>
      <div className={`product-card ${isImportant ? 'important' : ''}`}>
        <div className="header">
          <div className="title-wrap">
            <div className="title">{name}</div>
          </div>

          {tags?.length > 0 && (
            <div className="tags">
              {tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className="body">
          <div className="image-wrap">
            {image_url ? (
              <img src={image_url} alt="product" className="image" />
            ) : (
              <div className="no-image">No Image</div>
            )}
          </div>

          <div className="price">
            <div>
              <span className="label">初回</span>
              <span className="value">
                {price_first ? `¥${formatNumPrice(price_first)}` : '―'}
              </span>
            </div>
            <div>
              <span className="label">2回目以降</span>
              <span className="value">
                {price_after ? `¥${formatNumPrice(price_after)}` : '―'}
              </span>
            </div>
          </div>
        </div>

        <div className="footer">
          {medicines?.length > 0 && (
            <div className="section">
              <div className="section-title">薬の内訳</div>
              <div className="section-content medicine-list">
                {medicines.map((m) => m.name).join(' / ')}
              </div>
            </div>
          )}

          {treatment_policy && (
            <div className="section">
              <div className="section-title">期待できる効果・効能</div>
              <div className="section-content">{treatment_policy}</div>
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .product-card {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 14px;
    margin: 10px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-size: 14px;
    color: #333;

    &.important {
      border: 5px solid #e01616;
      border-radius: 20px;
    }
  }

  .header {
    margin-bottom: 14px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    background: #b2a577;
    padding: 15px;
    border-top-right-radius: 14px;
    border-top-left-radius: 14px;
    justify-items: center;

    .title {
      font-weight: bold;
      font-size: 16px;
      color: #fff;
    }

    .tags {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;

      .tag {
        background: #fff;
        color: #b2a577;
        border-radius: 6px;
        padding: 2px 5px;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }

  .body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 14px 0;
    padding: 15px;

    .image-wrap {
      width: 45%;
      display: flex;
      justify-content: center;
    }

    .image {
      width: 100%;
      border-radius: 10px;
      object-fit: contain;
    }

    .price {
      width: 50%;
      text-align: right;
      font-weight: 600;

      .label {
        color: #8a8a8a;
        font-size: 13px;
        margin-right: 4px;
      }

      .value {
        display: inline-block;
        font-size: 20px;
        color: #000;
      }

      div + div {
        margin-top: 6px;
      }
    }
  }

  .footer {
    margin-top: 12px;
    padding: 15px;

    .section {
      margin-top: 12px;

      .section-title {
        background: #f7f5ed;
        display: inline-block;
        padding: 4px 10px;
        border-radius: 6px;
        font-weight: 700;
        font-size: 13px;
        color: #8a7e5b;
        margin-bottom: 6px;
      }

      .section-content {
        margin-top: 4px;
        line-height: 1.5;
      }

      .medicine-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        .medicine-item {
          display: flex;
          align-items: center;
          gap: 4px;
          background: #fafafa;
          border-radius: 6px;
          padding: 3px 6px;
          font-size: 12px;

          img {
            width: 30px;
            height: 30px;
            border-radius: 4px;
            object-fit: contain;
          }
        }
      }
    }
  }
`

export default PlanMessage
